<template>
  <div v-if="show" class="browser-base">
    <div class="browser-permission">
      <div class="browser-permission__content">
        <div class="browser-permission__content__title">
          <h1>Permissão</h1>
        </div>
        <div class="browser-permission__content__description">
          <p>
            Para receber notificações, você precisa permitir o envio de
            notificações.
          </p>
        </div>
        <div>
          <md-button
            class="md-raised md-accent"
            style="margin-left: 0"
            @click="onDeny"
          >
            Negar
          </md-button>
          <md-button class="md-raised md-primary" @click.native="onAllow">
            Permitir
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from 'firebase/messaging'

import environment from '@/environment'
import { messaging } from '@/utils/firebase.helper'
import http from '@/utils/http'

export default {
  name: 'BrowserPermission',
  computed: {
    show() {
      return !this.$store.state.general.notificationAsked
    },
  },
  methods: {
    onAllow() {
      Notification.requestPermission((permission) => {
        this.$store.commit('setNotificationAsked', true)

        getToken(messaging, { vapidKey: environment.VAPID_KEY })
          .then(async (currentToken) => {
            if (currentToken) {
              await http.post(
                'accounts/notification',
                { token: currentToken },
                false
              )
            } else {
              console.error(
                'No registration token available. Request permission to generate one.'
              )
            }
          })
          .catch((err) => {
            console.error(err)
          })
      })
    },
    onDeny() {
      this.$store.commit('setNotificationAsked', true)
    },
  },
}
</script>

<style scoped lang="scss">
.browser-base {
  z-index: 999;
  background-color: white;

  margin: 1rem;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 25vw;

  @media (max-width: 599px) {
    width: 95%;
  }
  @media (min-width: 599px) and (max-width: 959px) {
    width: 50%;
  }

  border: 1px solid #ccc;
  border-radius: 0.2rem;

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1), 0 9px 11px 0 rgba(0, 0, 0, 0.1),
    0 9px 15px 0 rgba(0, 0, 0, 0.02);
}

.browser-permission {
  padding: 0.5rem;
}
</style>
